import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { 
    Container, 
    Row, Col, Card, 
    CardBody, CardTitle, Table,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, Modal, Alert, Input, Button, Badge} from "reactstrap";
    import { Link } from 'react-router-dom';

import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig, TOAST_OPTIONS } from '../../helpers/backend_helper';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";
import { useHistory } from 'react-router-dom';

    const GrievanceCases = () => {
        const history = useHistory()
        const [dCases, setDCases] = useState([])
        const [modal, setmodal] = useState(false);
        const [modal_details, setmodal_details] = useState(false);
        const [entryTypes, setEntryTypes] = useState(["Issue Detail Description","Findings","Recommendations","Employee Response"])
        const [raisedBy, setRaisedBy] = useState('')
        const [raisedByNo, setRaisedByNo] = useState('')
        const [employeesOptions, setEmployeesOptions] = useState([])
        const [caseOptions, setCaseOptions] = useState([])
        const [sendToNo, setSetToNo] = useState('')
        const [inditedNo, setInditedNo] = useState('')
        const [caseDetails, setCaseDetails] = useState('')
        const [copyTo, setCopyTo] = useState('')
        const [witnesses, setWitnesses] = useState([])
        const [ctype, setType] = useState('')
        const [category, setCategory] = useState('')
        const [raisedDate, setRaisedDate] = useState(formatDate(new Date))
        const [incidentDate, setIncidentDate] = useState(formatDate(new Date))
        const [gDCode, setGDCode] = useState('')
        const [selectedEntryType, setSelectedEntryType] = useState('Issue Detail Description')
        const [wholeCase, setWholeCase] = useState(null)
        const [isLoading, setIsLoading] = useState(false)

        toastr.options = TOAST_OPTIONS;

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_case = () => {
            setmodal(!modal);
            removeBodyCss();
        }
        const tog_details = () => {
            setmodal_details(!modal_details);
            removeBodyCss();
        }
        const handleClickDetails = (t) =>{
            setWholeCase(t)
            tog_details();
        }
        const handleSendChange = (x) =>{
            setSetToNo(x.value)
        }
        const handleInditedChange = (x) =>{
            setInditedNo(x.value)
        }
        const handleCaseChange = (x) =>{
            setCaseDetails(x.value.Description)
            setGDCode(x.value.Code)
            setCategory(x.value.Type)
            setType(x.value.DesciplinaryCategory)
        }
        const handleCoptToChange = (x) =>{
            setCopyTo(x.value)
        }
        const handleWitnessChange = (x) =>{
            setWitnesses(x)
        }
        const handleSearch = () =>{
            toastr.info("Searching.. please wait")
        }
        const handleSaveCase = () =>{
            let gLines = [
                {
                    EntryType: selectedEntryType,
                    Description: caseDetails
                }]
            const data = {
                EmployeeNo: inditedNo,
                CaseCategory: ctype,
                Type: category,
                GDCode: gDCode,
                CaseRegisteredByNo: raisedByNo,
                IncidentDate: incidentDate,
                DateRaised: raisedDate,
                SendGrievanceTo: sendToNo,
                CopyGrievancyTo: copyTo,
                submitTO: 'Individual Employee',
                grievanceLines:gLines
            }
            setIsLoading(true)
            axios.post(url.GRIEVENCES, data, HRConfig).then((r)=>{
                if(r.request.status == '201'){
                    toastr.success("Case has been logged, you can now submit it")
                    tog_case()
                    getData()
                }else{
                    toastr.error("Could not Create Case")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
        const handleSubmitCase = () => {
            setIsLoading(true)
            const data = {no: wholeCase.No }
            axios.post(url.NOTIFY_SUPERVISOR, JSON.stringify(data), HRConfig).then((r)=>{
                //console.log(r)
                setIsLoading(false)
                toastr.error("Supervisor Notification Submitted")
                getData()
                tog_details()
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
                toastr.error(e.response.data.error.message)
            })

        }
        const getData = () =>{
            setIsLoading(true)
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setRaisedByNo(obj.uid)
                setRaisedBy(obj.username)
                
                axios.get(`${url.GRIEVENCES}?$filter=CaseRegisteredByNo eq '${obj.uid}'`, HRConfig).then((r)=>{ 
                    setIsLoading(false)
                    setDCases(r.data.value)
                    console.log(r.data.value)
                }).catch((e)=>{ console.log(e); setIsLoading(false); })
               /*
                axios.get(`${url.GRIEVENCES}`, HRConfig).then((r)=>{ 
                  setIsLoading(false)
                  setDCases(r.data.value)
                  console.log(r.data.value)
                }).catch((e)=>{ console.log(e); setIsLoading(false); })
                */
            }
            axios.get(url.EMPLOYEES, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((e)=>{
                    options.push({label: `${e.FirstName} ${e.LastName}`,value: e.No})
                })
                setEmployeesOptions(options)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.GRIEVANCE_TYPES, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((e)=>{
                    options.push({label: `${e.Description}`,value: e})
                })
                setCaseOptions(options)
            }).catch((e)=>{ console.log(e) })
        }
        useEffect(()=>{
           getData()
        },[])
        const { SearchBar } = Search;
        const columns = [
            {
              dataField: 'No',
              text: 'No',
              sort: true,
              formatter: noFormatter
            },
            {
              dataField: 'CaseCategory', 
              isDummyField: true,
              text: 'Category',
              sort: true,
              formatter: categoryFormatter
            }, 
            {
                dataField: 'EmployeeNo',
                isDummyField: true,
                text: 'Raised By',
                sort: true,
                formatter: raisedByFormatter
              }, 
 
            {
              dataField: 'PostingDate',
              text: 'Name of Indited',
              sort: true,
              isDummyField: true,
              formatter: inditedFormatter
            }, 

            {
              dataField: 'Status',
              text: 'Status',
              sort: true,
              formatter: statusFormatter
            },
            {
              dataField: "action",
              isDummyField: true,
              text: "",
              formatter: actionFormatter
            }];
      
            const defaultSorted = [{
              dataField: 'No',
              order: 'desc'
            }];
      
            function categoryFormatter(cellContent,row){
              return(
                <span>{row.DisciplinaryCaseDescripiton}<br/> {row.CaseCategory}{" "}{row.Type}</span>
              )
            }
            function raisedByFormatter(cellContent,row){
                return(
                  <span> {row.CaseRegisteredByName}<br/>{row.CaseRegisteredByNo} <br/><i>On {row.DateRaised}</i></span>
                )
              }
            function inditedFormatter(cellContent, row){
              if(row.NatureofGrievance == "Person"){
                return(
                  <span> <i>{row.NatureofGrievance}</i><br/>{row.NameOfIndicted}<br/>{row.EmployeeNo}</span>
                )
              }else{
                return(
                  <span> <i>{row.NatureofGrievance}</i><br/>{row.ProcessType}</span>
                )
              }
              
            }
            function noFormatter(cellContent, row){
              return(
                <strong>{cellContent}</strong>
              )
            }
      
            function actionFormatter(cellContent, row){
              return(
                <>
                <div className="d-flex gap-3">
                <UncontrolledDropdown direction="left">
                    <DropdownToggle href="#" className="card-drop" tag="i">
                      <i className="mdi mdi-dots-horizontal font-size-18" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                 
                      <DropdownItem
                        onClick={()=>{ history.push(`/grievance-details/${row.SystemId}`); }}
                      >
                        <i className="fas fa-address-card text-warning me-1" />
                        Grievance Details
                      </DropdownItem>
                      
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </>
              )
            }
            function statusFormatter(cellContent, row) {
              if (row.Status == "Open") {
                return (
                  <div>
                      <Badge className="me-2 bg-danger">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Resolved"){
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Withdrawn(Cancelled)"){
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-warning">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
            function paFormatter(cellContent, row) {
              if (row.ConvertToAppraisal == "No") {
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Grievances | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Cases" />
                        <Row>
                        <Col lg={12}>
                                {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                            </Col>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                             
                  
                               {(dCases.length > 0) && (<>

                                    <ToolkitProvider
                                        keyField="No"
                                        data={ dCases }
                                        columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                  <Col lg={10}>
                                                  <div  className="rounded bg-light d-grid gap-2">
                                           
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                 
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                    <Link
                                                      className="btn btn-primary"
                                                      to="/raise-grievance"
                                                    >
                                                      <i className="mdi mdi-plus me-1" />
                                                      Raise Case
                                                    </Link>
                                                  </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                <Col xl="12">
                                                    <div className="table-responsive">
                                                
                                                    <BootstrapTable 
                                                    keyField='No' 
                                                    data={ dCases } 
                                                    columns={ columns } 
                                                    striped
                                                    hover
                                                    condensed
                                                    bordered={ false }
                                                    noDataIndication="No Records" 
                                                    defaultSorted={ defaultSorted }
                                                    classes={ "table align-middle table-nowrap table-check" }
                                                        {...toolkitProps.baseProps}
                                                    />
                                                </div>
                                                </Col>
                                                </Row>
                                                </React.Fragment>
                                                
                                        )
                                        }
                                    </ToolkitProvider>
                  

                              
                                </>)}
                                {(dCases.length < 1) && (<>
                                    <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                
                                    
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>All Done</h5>
                                        <p className="text-muted">
                                                No Cases found
                                        </p>
                                        </div>
                                    </div>
                                    <div className="text-center mt-4">
                                        <Link
                                        to="/raise-grievance"
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Raise Grievance <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                              
                                </Col>
                            </Row>
                                </>)}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default GrievanceCases;